
const data = {
    "article":[
        {
            "title":"Goのstring型の内部表現をみてみる",
            "date":"2024/9",
            "link":"https://zenn.dev/sino_429/articles/20624c604bc7d3"
        },
        {
            "title":"Goにおけるループの評価タイミングの違いと動作への影響",
            "date":"2024/9",
            "link":"https://zenn.dev/sino_429/articles/1d3ee0c8c38b00"
        },
        {
            "title":"Goのマップの反復処理の順序は保証されていない",
            "date":"2024/9",
            "link":"https://zenn.dev/sino_429/articles/ce8918c578c251"
        },
        {
            "title":"Goのピリオドインポートとは",
            "date":"2024/9",
            "link":"https://zenn.dev/sino_429/articles/def384aa7bddc4"
        },
        {
            "title":"2023 振り返り",
            "date":"2023/12",
            "link":"https://mahiro72.hatenablog.com/entry/2023/12/31/145824"
        },
        {
            "title":"少し変わったキャリアの新卒エンジニアのおすすめ書籍 7選",
            "date":"2023/12",
            "link":"https://qiita.com/mahiro72/items/2663ec94dd7f1c847bf0"
        },
        {
            "title":"振り返り ( 2023/1 )",
            "date":"2022/2",
            "link":"https://mahiro72.hatenablog.com/entry/2023/02/27/230147"
        },
        {
            "title":"2022年振り返り",
            "date":"2022/12",
            "link":"https://mahiro72.hatenablog.com/entry/2022/12/31/212331"
        },
        {
            "title":"振り返り ( 2022/12 )",
            "date":"2022/12",
            "link":"https://mahiro72.hatenablog.com/entry/2022/12/30/172818"
        },
        {
            "title":"ハッカソンのアイデアを洗練させる",
            "date":"2022/12",
            "link":"https://qiita.com/mahiro72/items/9dd60080f889e9041fd3"
        },
        {
            "title":"【2022版】学生向けハッカソン一覧",
            "date":"2022/12",
            "link":"https://qiita.com/mahiro72/items/934ddb15edf8b45e35d6"
        },
        {
            "title":"JPHACKS 2022 のみぱら 感想戦🔥",
            "date":"2022/12",
            "link":"https://note.com/sino_72/n/nfe4df992fa90"
        },
        {
            "title":"振り返り ( 2022/11 )",
            "date":"2022/12",
            "link":"https://mahiro72.hatenablog.com/entry/2022/12/07/213747"
        },
        {
            "title":"振り返り ( 2022/10 )",
            "date":"2022/11",
            "link":"https://mahiro72.hatenablog.com/entry/2022/11/17/193853"
        },
        {
            "title":"振り返り ( 2022/9 )",
            "date":"2022/10",
            "link":"https://mahiro72.hatenablog.com/entry/2022/10/10/190742"
        },
        {
            "title":"技育展2022 MeetHack 感想戦🔥",
            "date":"2022/10",
            "link":"https://note.com/sino_72/n/n80bff7feda49"
        },
        {
            "title":"振り返り ( 2022/8 )",
            "date":"2022/9",
            "link":"https://mahiro72.hatenablog.com/entry/2022/09/02/203035"
        },
        {
            "title":"SPAJAMハッカソン2022感想戦🔥",
            "date":"2022/8",
            "link":"https://note.com/sino_72/n/nf2b42428d098"
        },
        {
            "title":"振り返り ( 2022/7 )",
            "date":"2022/8",
            "link":"https://mahiro72.hatenablog.com/entry/2022/08/04/183326"
        },
        {
            "title":"技育CAMP vol.5ハッカソン感想戦",
            "date":"2022/7",
            "link":"https://note.com/sino_72/n/n5b8cd460da5c"
        },
        {
            "title":"【備忘録】Team Geek ―Googleのギークたちはいかにしてチームを作るのか",
            "date":"2022/7",
            "link":"https://mahiro72.hatenablog.com/entry/2022/07/28/221656"
        },
        {
            "title":"振り返り ( 2022/6 )",
            "date":"2022/7",
            "link":"https://mahiro72.hatenablog.com/entry/2022/07/01/213552"
        },
        {
            "title":"技育CAMP vol.4ハッカソン感想戦",
            "date":"2022/6",
            "link":"https://note.com/sino_72/n/n7102ad343284"
        },
        {
            "title":"Herokuにサブディレクトリをデプロイするのに命削った話",
            "date":"2022/6",
            "link":"https://qiita.com/mahiro72/items/86383602c47696ac9110"
        },
        {
            "title":"【実践】2つコミットを戻したいそこのあなたへ",
            "date":"2022/6",
            "link":"https://qiita.com/mahiro72/items/3c424e0d915a2a3b69e5"
        },
        {
            "title":"振り返り ( 2022/5 )",
            "date":"2022/6",
            "link":"https://mahiro72.hatenablog.com/entry/2022/06/02/191304"
        },
        {
            "title":"【備忘録】Java本格入門 Part1",
            "date":"2022/5",
            "link":"https://mahiro72.hatenablog.com/entry/2022/05/28/204058"
        },
        {
            "title":"【備忘録】詳説 Cポインタ",
            "date":"2022/5",
            "link":"https://mahiro72.hatenablog.com/entry/2022/05/21/190402"
        },
        {
            "title":"【備忘録】ネットワークはなぜつながるのか",
            "date":"2022/5",
            "link":"https://mahiro72.hatenablog.com/entry/2022/05/14/191117"
        },
        {
            "title":"Golangのappend()の実装とパフォーマンスについて",
            "date":"2022/5",
            "link":"https://qiita.com/mahiro72/items/475ff4f26680d73e219e"
        },
        {
            "title":"振り返り ( 2022/4 )",
            "date":"2022/5",
            "link":"https://mahiro72.hatenablog.com/entry/2022/05/02/001357"
        },

        {
            "title":"そもそもURLってなんだっけ...?",
            "date":"2022/4",
            "link":"https://qiita.com/mahiro72/items/b52a6514067ac514fdfd"
        },
        {
            "title":"42TokyoのPiscineを合格した話🗼",
            "date":"2022/3",
            "link":"https://note.com/sino_72/n/n8f1b5344925b"
        },
        {
            "title":"Googleで記号を検索する際のコツ",
            "date":"2022/3",
            "link":"https://qiita.com/mahiro72/items/3c3097d89d31a26719e3"
        },
        {
            "title":"SQL100本ノックの環境構築と少し実践!🐘",
            "date":"2022/2",
            "link":"https://qiita.com/mahiro72/items/f468c0450f4ccecc300a"
        },
        {
            "title":"[golang error]go: gopkg.in/yaml.v2@v2.2.2: unknown revision v2.2.2を解決した話",
            "date":"2022/1",
            "link":"https://qiita.com/mahiro72/items/6f87867fb057210308d3"
        },
        {
            "title":"2021年を振り返って",
            "date":"2021/12",
            "link":"https://zenn.dev/sino_429/articles/84832d9f2435fb"
        },
        {
            "title":"[python] [cx_Oracle.DatabaseError: DPI-1047: Cannot locate a 64-bit Oracle Client library] が起きた時の対処法３選",
            "date":"2021/10",
            "link":"https://qiita.com/mahiro72/items/1d5384a6e503d3d585dd"
        },
    ]
}

export default data;